import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Layout } from './components/Layout';
import { AuthGuard } from './features/auth/AuthGuard';
import { LoginPage } from './features/auth/LoginPage';
import { MfaSetupPage } from './features/auth/MfaSetupPage';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { GiftCodesPage } from './features/gift-codes/GiftCodesPage';
import { NodePathEditor } from './features/nodes/NodePathEditor';
import { StoryDetailPage } from './features/stories/StoryDetailPage';
import { StoryListPage } from './features/stories/StoryListPage';
import { TogglesPage } from './features/toggles/TogglesPage';
import { TokensPage } from './features/tokens/TokensPage';
import { UsersPage } from './features/users/UsersPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route element={<AuthGuard />}>
            <Route element={<Layout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/stories" element={<StoryListPage />} />
              <Route path="/stories/:storyId" element={<StoryDetailPage />} />
              <Route path="/stories/:storyId/free-content" element={<NodePathEditor />} />
              <Route path="/tokens" element={<TokensPage />} />
              <Route path="/gift-codes" element={<GiftCodesPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/toggles" element={<TogglesPage />} />
              <Route path="/mfa-setup" element={<MfaSetupPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
